import pushModel from "@/mixin/store/api/pushModel";
import fetchModels from "@/mixin/store/api/fetchModels";

export default {
    actions: {
        pushScale(context, data) {
            return pushModel(context, 'scales', data, 'updateScale')
        },
        fetchScales(context, search) {
            return fetchModels(context, 'scales?', search.page, 'updateScales');
        },
    },
    mutations: {
        updateScale(state, data) {
            state.scale = data
        },
        updateScales(state, data) {
            state.scales = data
        },
    },
    state: {
        scale: null,
        scales: {
            models: [],
        },
    },
    getters: {
        getScale(state) {
            return state.scale
        },
        getScales(state) {
            return state.scales.models
        },
    }
}
